import { useState } from 'react';
import { createPortal } from 'react-dom';
import { Link } from 'react-router-dom';
import { useTheme } from '@/state/ThemeContext';
import { Icon } from '@/components/ui';

export function LandingNav() {
  const { isDark, toggleTheme } = useTheme();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className="landing-nav">
      <div className="landing-nav-inner">
        <Link to="/" className="logo" aria-label="Accueil Ma Facture">
          <span className="logo-mark">M</span>
          <span className="logo-text">
            <strong>Ma Facture</strong>
            <span className="logo-badge">IA • MAD</span>
          </span>
        </Link>

        {/* Desktop Navigation Links */}
        <nav className="landing-nav-links">
          <a href="#features">Fonctionnalités</a>
          <a href="#how">Comment ça marche</a>
        </nav>

        {/* Desktop Quick Actions */}
        <div className="landing-nav-actions">
          <button
            type="button"
            className="theme-toggle-btn"
            onClick={toggleTheme}
            title={isDark ? 'Passer au mode clair' : 'Passer au mode sombre'}
            aria-label={isDark ? 'Mode clair' : 'Mode sombre'}
          >
            <Icon name={isDark ? 'sun' : 'moon'} size={18} />
          </button>
          <Link to="/auth" className="btn btn-ghost btn-sm">
            Connexion
          </Link>
          <Link to="/auth?tab=signup" className="btn btn-primary btn-sm cta-glow">
            Essai gratuit
          </Link>

          {/* Mobile Hamburger Button */}
          <button
            type="button"
            className="landing-hamburger-btn"
            onClick={() => setMobileMenuOpen((o) => !o)}
            aria-label="Menu principal"
            aria-expanded={mobileMenuOpen}
          >
            <Icon name={mobileMenuOpen ? 'x' : 'menu-dots'} size={20} />
          </button>
        </div>
      </div>

      {/* Mobile Menu Dropdown Sheet */}
      {mobileMenuOpen && createPortal((
        <div className="landing-mobile-menu" role="presentation" onClick={() => setMobileMenuOpen(false)}>
          <button className="landing-mobile-backdrop" type="button" aria-label="Fermer le menu" />
          <aside className="landing-mobile-sidebar" aria-label="Navigation principale" onClick={(event) => event.stopPropagation()}>
            <div className="landing-sidebar-heading"><span>Navigation</span><button type="button" className="landing-sidebar-close" onClick={() => setMobileMenuOpen(false)} aria-label="Fermer le menu"><Icon name="x" size={19} /></button></div>
            <nav className="landing-mobile-nav-links">
            <a href="#features" onClick={() => setMobileMenuOpen(false)}>
              Fonctionnalités
            </a>
            <a href="#how" onClick={() => setMobileMenuOpen(false)}>
              Comment ça marche
            </a>
            </nav>

          <div className="landing-mobile-menu-footer">
            <div className="mobile-theme-row">
              <span style={{ fontSize: 13, color: 'var(--neo-text-2)' }}>Mode d'affichage</span>
              <button
                type="button"
                className="theme-toggle-btn mobile-theme-btn"
                onClick={toggleTheme}
                title={isDark ? 'Passer au mode clair' : 'Passer au mode sombre'}
              >
                <Icon name={isDark ? 'sun' : 'moon'} size={16} />
                <span>{isDark ? 'Mode Clair' : 'Mode Sombre'}</span>
              </button>
            </div>
            <div className="landing-mobile-btns">
              <Link
                to="/auth"
                className="btn btn-secondary btn-md"
                onClick={() => setMobileMenuOpen(false)}
                style={{ width: '100%', justifyContent: 'center' }}
              >
                Se connecter
              </Link>
              <Link
                to="/auth?tab=signup"
                className="btn btn-primary btn-md"
                onClick={() => setMobileMenuOpen(false)}
                style={{ width: '100%', justifyContent: 'center' }}
              >
                Créer un compte gratuit
              </Link>
            </div>
          </div>
          </aside>
        </div>
      ), document.body)}
    </header>
  );
}
